import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MuiThemeProvider, createTheme } from '@material-ui/core';
import { resultsConfigSelector } from 'ctm-selectors';
import Dialog from '@material-ui/core/Dialog';
import { withRules, SimpleFlexbox, Text, ModalCloseIcon } from 'ctm-components';
import styles from './grey_modal.css';

const theme = createTheme({
    overrides: {
        MuiPaper: {
            root: {
                padding: '2rem',
                // To fix the absolute-positioned close icon being cut off
                overflowY: 'unset !important'
            }
        }
    }
});

/**
 * This is the Grey Import Modal.
 * @param {Object} props React props.
 * @returns {GreyImportModal} The GreyImport modal
 */
const _GreyModal =  (props) => {
    const { GreyImportModalIsOpen, closeModal } = props;

    /**
     * Render top-right modal close icon button
     * @return {Node} the CloseIcon button
     */
    const renderCloseIcon = () => {
        const closeIconProps = { onClickFunction: closeModal };
        return React.createElement(ModalCloseIcon, closeIconProps);
    };

    return (
        <MuiThemeProvider theme={theme}>
            <Dialog fullWidth open={GreyImportModalIsOpen} onClose={closeModal} disableBackdropClick disableEscapeKeyDown>
                <SimpleFlexbox display="flex" column>
                    <Text tagName="h3" color="brand_primary">Grey Import</Text>
                    <p className={styles.grey_import_text}>
                        Grey imports are new or used vehicles that are legally imported from another country outside of the maker’s official distribution channels. The term applies to both privately imported models and commercial imports.Unfortunately, none of the insurers on our panel offer insurance for grey import vehicles. You may want to refer to the Insurance Council of Australia's "Find an Insurer" website at www.findaninsurer.com.au and they may be able to provide you with a list of companies who can assist you with cover.
                    </p>
                </SimpleFlexbox>
                {renderCloseIcon()}
            </Dialog>
        </MuiThemeProvider>
    );
};

_GreyModal.propTypes = {
    GreyImportModalIsOpen: PropTypes.bool,
    closeModal: PropTypes.func
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} state - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */
const mapStateToProps = (state) => {
    const GreyImportModal = resultsConfigSelector(state).getIn(['helpers', 'GreyImport']);

    return {
        GreyImportModalIsOpen: GreyImportModal ? GreyImportModal.open : false
    };
};

const GreyModal = withRules(connect(mapStateToProps)(_GreyModal));

export { _GreyModal, GreyModal };
